import Label from 'src/components/Label';

export const RegulatedOfferLabel = () => (
  <Label color="warning" sx={{ mr: 1 }}>
    Regulations Apply
  </Label>
);
